module.exports = __webpack_public_path__ + "img/fragebogen_zur_erfassung_von_glueck.6cc4353b.png";